/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {GenericObject} from '@ion/core/src/types/entities';
import {EntityExportState} from '../reducers/exporter';

// input selectors ...
const selectShowExport = ({exporter: {current: {show}}}) => show;
const selectCurrent    = ({exporter: {current}}) => current;
const selectPendingExport = ({exporter: {current: {pending}}}) => pending;
const selectGeofenceEventsExport = ({exporter}) => exporter;

// output selectors ...
export const showExportSelector = createSelector(selectShowExport,
  (showExport: boolean): boolean => showExport
);

export const pendingExportSelector = createDeepEqualSelector(selectPendingExport,
  (pending: GenericObject): GenericObject => pending
);

export const exporterCurrentSelector = createDeepEqualSelector(selectCurrent,
  (current: EntityExportState): EntityExportState => current
);

export const exporterCurrentPendingSelector = createDeepEqualSelector(selectCurrent,
  (current: EntityExportState): any => current.pending
);

export const geofenceEventsExportSelector = createDeepEqualSelector(selectGeofenceEventsExport,
  (exporter: GenericObject): any => exporter.current
);
